import { Paragraph } from "@datagame/ui";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import styles from "./ChartHeader.module.scss";

export interface ChartHeader extends PropsWithChildren {
  respondersCount?: number;
}

export const ChartHeader = ({ children, respondersCount }: ChartHeader) => {
  const { t } = useTranslation();

  return (
    <div className={styles.chartHeader}>
      <Paragraph weight="font-bold" color="secondary">
        {children}
      </Paragraph>
      {respondersCount && (
        <Paragraph size="small" color="secondary">
          {t("report:respondersCount", { count: respondersCount })}
        </Paragraph>
      )}
    </div>
  );
};
